import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { getVipData, vipReward } from "@/api/php/user";
import { Toast } from "vant";

import vipbg0 from "@/assets/images/vip_bg_0.png";
import vipbg1 from "@/assets/images/vip_bg_1.png";
import vipbg2 from "@/assets/images/vip_bg_2.png";
import vipbg3 from "@/assets/images/vip_bg_3.png";
import vipbg4 from "@/assets/images/vip_bg_4.png";
import vipbg5 from "@/assets/images/vip_bg_5.png";

// vip_task_0.png
import task0 from "@/assets/images/vip_task_0.png";
import task1 from "@/assets/images/vip_task_1.png";
import task2 from "@/assets/images/vip_task_3.png";
import task3 from "@/assets/images/vip_task_4.png";
import task4 from "@/assets/images/vip_task_5.png";
import task5 from "@/assets/images/vip_task_6.png"; 
import vipimg1 from "@/assets/images/vip_level_1.png";
import vipimg2 from "@/assets/images/vip_level_2.png";
import vipimg3 from "@/assets/images/vip_level_3.png";
import vipimg4 from "@/assets/images/vip_level_4.png";
import vipimg5 from "@/assets/images/vip_level_5.png";

import vipjf2 from "@/assets/images/vipjf88.png";
import vipjf3 from "@/assets/images/vipjf188.png";
import vipjf4 from "@/assets/images/vipjf388.png";
import vipjf5 from "@/assets/images/vipjf888.png";
 
import { YMPush } from "@/uitls/uitls"; 
import { cheackQuery, goHome, nativeToNewWeb, ToBack, toSetting } from "@/uitls/native";
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'VipLevels',
  setup(__props, { expose }) {
  expose();

const th = process.env.VUE_APP_Language as string;
const { t } = useI18n()
const router = useRouter();
const route = useRoute();

const viptitle0 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_title_0.png`);
const viptitle1 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_title_1.png`);
const viptitle2 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_title_2.png`);
const viptitle3 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_title_3.png`);
const viptitle4 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_title_4.png`);
const viptitle5 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_title_5.png`);

const taskbtn = require(`@/assets/${process.env.VUE_APP_NAME}/taskbtn.png`);
const taskbtn1 = require(`@/assets/${process.env.VUE_APP_NAME}/taskbtn1.png`);


const vipLevelBg = [vipbg0, vipbg1, vipbg2, vipbg3, vipbg4, vipbg5];
const vipLevelTitle = [
  viptitle0,
  viptitle1,
  viptitle2,
  viptitle3,
  viptitle4,
  viptitle5,
];
const vipLevelImg = [vipimg1, vipimg2, vipimg3, vipimg4, vipimg5];
const textColor = [
  "#E3E8AB",
  "#ffffff",
  "#A0A9B3",
  "#C0A403",
  "#FFFFFF",
  "#FFFFFF",
];

const VIPDESC = [
  "",
  t('tips.beat40'),
  t('tips.beat60'),
  t('tips.beat78'),
  t('tips.beat88'),
  t('tips.beat98'),
];
const LEVEL = [t('me.lvxl'), t('me.lvhtqm'), t('me.lvbyqt'), t('me.lvhjqy'), t('me.lvbjqx'), t('me.lvzsqw')];
let tmpLevel = ref(0);
let Circle = ref(0);
let totalexp = ref(0);
let is_send = ref(0);
let nextexp = ref(0);
let score = ref(0);
//nav=1 是隐藏navbar

onMounted(() => {
  cheackQuery(route);
  getdata();
  YMPush('MAIN', 'VipLevelPage');
  // let token = Storage.get("token");
});
const listData = ref([])
const getdata = async () => {
  // 获取用户等级
  const res: any = await getVipData();
  if (res.code == 200) {
    //   等级
    tmpLevel.value = res.data.level;
    // 红包是否领取
    is_send.value = res.data.is_send;
    // 成长值
    nextexp.value = res.data.nextexp;
    totalexp.value = res.data.totalexp;
    // 红包数量
    score.value = res.data.score;
    // 进度条
    Circle.value = ((totalexp.value - nextexp.value) / totalexp.value) * 100;
    listData.value = res.data.level_task
    console.log(res.data);
  } else {
    console.log(res);
  }
};
const onClickReward = async () => {
  // 领取红包
  if (is_send.value == 0) {
    Toast.fail(t('me.nylqgl'));
  } else {
    const res: any = await vipReward();
    if (res.code == 200) {
      if (res.data.ret == 1) {
        is_send.value = 0;
        getdata()
        Toast.success(t('me.lingquceng'))
      }
    }
    console.log(res.data);
  }
};
const getTaskIcon = (type) => {

  switch (type) {
    case 1:
      return task3
    case 2:
      return task0
    case 3:
      return task2
    case 5:
      return task5
    case 51:
      return task4
    default:
      return ""
  }
}

const taskToRouter = (type) => {
  switch (type) {
    case 1:
      // return router.push('/integralwallet')
      return nativeToNewWeb(router, '/integralwallet?a=0');
    case 2:
      return goHome(router)
    case 3:
      return goHome(router)
    case 5:
      // return router.push('/invitef')
      return nativeToNewWeb(router, '/invitef?a=0');
    case 51:
      return toSetting(router)
    default:
      return ""
  }
}
const getJfTitle = () => {
  switch (tmpLevel.value) {
    case 2:
      return t('me.lvby')
    case 3:
      return t('me.lvhj')
    case 4:
      return t('me.lvbj')
    case 4:
      return t('me.lvzs')
    default:
      break;
  }
}

const getCircleBg = () => {
  switch (tmpLevel.value) {
    case 0:
      return "#8B8F60"
    case 1:
      return "#BE8040"
    case 2:
      return "#A5B0BE"
    case 3:
      return "#D4CA72"
    case 4:
      return "#A49ECC"
    case 4:
      return "#B86ED1"
    default:
      return "#8B8F60"
  }
}

const getJfBg = () => {
  switch (tmpLevel.value) {
    case 2:
      return vipjf2
    case 3:
      return vipjf3
    case 4:
      return vipjf4
    case 4:
      return vipjf5
    default:
      break;
  }
}


const __returned__ = { th, t, router, route, viptitle0, viptitle1, viptitle2, viptitle3, viptitle4, viptitle5, taskbtn, taskbtn1, vipLevelBg, vipLevelTitle, vipLevelImg, textColor, VIPDESC, LEVEL, tmpLevel, Circle, totalexp, is_send, nextexp, score, listData, getdata, onClickReward, getTaskIcon, taskToRouter, getJfTitle, getCircleBg, getJfBg, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})